module.exports = __webpack_public_path__ + "static/media/sortDes.236cfa7e.svg";